module.exports = __webpack_public_path__ + "static/pranaa-bw-min-ea8ac98abd2bbd66c332d74bc999a4f0.jpg";